module.exports = __webpack_public_path__ + "img/pr-21.f6c4719e.png";